(() => {
  const normal = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/ß/g, 'ss').replace(/ø/g, 'o').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  class CatalogEngine {
    constructor(snapshot) {
      if (snapshot.schema !== 1 || !Array.isArray(snapshot.rows)) throw Error('Invalid catalog');
      this.version = snapshot.version;
      this.rows = snapshot.rows.map((r, order) => ({r, order, text: normal(r[1] + ' ' + r[2]), artist: normal(r[2]), format: ({vinyl:1,cd:2,cassette:4,cassettes:4})[normal(snapshot.formats?.[r[0]] || 'vinyl')] || 0}));
      this.rows.forEach(p => {p.words = p.text.split(' ');});
    }
    run(state = {}) {
      const q = normal(state.q), terms = q.split(' ').filter(Boolean);
      const edition = Number(state.edition) || 0, types = Number(state.type) || 0;
      const sound = Number(state.sound) || 0, language = Number(state.language) || 0, era = Number(state.era) || 0;
      const min = state.min === '' || state.min == null ? 0 : Math.round(Number(state.min) * 100);
      const max = state.max === '' || state.max == null ? Infinity : Math.round(Number(state.max) * 100);
      const counts = {format: Array(3).fill(0), edition: Array(5).fill(0), sound: Array(14).fill(0), type: Array(5).fill(0), era: Array(8).fill(0), language: Array(11).fill(0)};
      const matches = [];
      for (const p of this.rows) {
        const r = p.r;
        if (state.scope === 'pre-loved' && !(r[7] & 16)) continue;
        const scopeFormat = {vinyl:1,cd:2,cassettes:4}[state.scope];
        if (scopeFormat && p.format !== scopeFormat) continue;
        if (terms.length && !terms.every(t => p.words.some(w => w.startsWith(t)))) continue;
        if (r[3] < min || r[3] > max) continue;
        const e = (r[7] & edition) === edition, t = (r[8] & types) === types;
        const s = !sound || Boolean(r[4] & sound), l = !language || Boolean(r[6] & language);
        const a = !era || (r[5] >= 0 && Boolean((1 << r[5]) & era));
        const f = !state.format || Boolean(p.format & Number(state.format));
        if (e && t && s && l && a) for (let i=0;i<3;i++) if (p.format & (1<<i)) counts.format[i]++;
        if (!f) continue;
        if (e && t && s && l && a) matches.push(p);
        if (t && s && l && a) for (let i = 0; i < 5; i++) {
          const bit = 1 << i, others = edition & ~bit;
          if ((r[7] & others) === others && (r[7] & bit)) counts.edition[i]++;
        }
        if (e && s && l && a) for (let i = 0; i < 5; i++) {
          const bit = 1 << i, others = types & ~bit;
          if ((r[8] & others) === others && (r[8] & bit)) counts.type[i]++;
        }
        if (e && t && l && a) for (let i = 0; i < 14; i++) if (r[4] & (1 << i)) counts.sound[i]++;
        if (e && t && s && a) for (let i = 0; i < 11; i++) if (r[6] & (1 << i)) counts.language[i]++;
        if (e && t && s && l && r[5] >= 0) counts.era[r[5]]++;
      }
      const relevance = p => p.artist === q ? 100 : p.artist.startsWith(q) ? 80 : p.text.startsWith(q) ? 60 : p.text.includes(q) ? 40 : 0;
      if (state.sort === 'price-ascending') matches.sort((a,b) => a.r[3] - b.r[3] || a.order - b.order);
      else if (state.sort === 'price-descending') matches.sort((a,b) => b.r[3] - a.r[3] || a.order - b.order);
      else if (state.sort === 'title-ascending') matches.sort((a,b) => a.r[1].localeCompare(b.r[1], 'nl') || a.order - b.order);
      else if (q) matches.sort((a,b) => relevance(b) - relevance(a) || a.order - b.order);
      const pages = Math.max(1, Math.ceil(matches.length / 20));
      const page = Math.max(1, Math.min(pages, Number(state.page) || 1));
      return {total: matches.length, page, pages, counts, handles: matches.slice((page-1)*20, page*20).map(p => p.r[0])};
    }
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {CatalogEngine, normal};
  else self.SjelfCatalogEngine = CatalogEngine;
  if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope) {
    let engine;
    self.onmessage = async event => {
      const {id, kind, snapshot, state} = event.data;
      try {
        if (kind === 'init') {engine = new CatalogEngine(snapshot); self.postMessage({id, ready:true});}
        else if (engine) self.postMessage({id, result:engine.run(state)});
        else throw Error('Catalog not ready');
      } catch (e) {self.postMessage({id, error:e.message});}
    };
  }
})();

